import { ApiProperty } from "@nestjs/swagger";
import { IsOptional } from "class-validator";

export class ForkLiftJobUpdateDto {
    @ApiProperty()
    plantId: number;
    @ApiProperty()
    jobCode: string;
    @ApiProperty()
    palletId: number;
    @ApiProperty()
    targetPosition: number;
    @ApiProperty()
    realPosition: number;
    @ApiProperty()
    @IsOptional()
    machineName: string;
    @ApiProperty()
    @IsOptional()
    OperatorName: string;
    @ApiProperty()
    updatedAt: Date;    
    @ApiProperty()
    updatedUser: string;    
  }
